import { render, staticRenderFns } from "./ChatMsgInput.vue?vue&type=template&id=6c5240c4&"
import script from "./ChatMsgInput.vue?vue&type=script&lang=js&"
export * from "./ChatMsgInput.vue?vue&type=script&lang=js&"
import style0 from "./ChatMsgInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VProgressLinear,VTooltip})
